import { Col, Flex, notification, Row } from "antd";

import { useEffect } from "react";
import { useProjectsInfo } from "projects/queries";
import { EngineerDashboardProjectsCard } from "./engineer-dashboard-projects-card/EngineerDashboardProjectsCard";
import variables from "../../../../_variables.scss";
import { SalesTargetTimePeriods } from "users/components";
import { NotesList } from "notes/components";
import { useBoundStore } from "store";

export const EngineerDashboard = () => {
  const { currentOrganization } = useBoundStore();
  const {
    data: projectsInfo,
    isSuccess,
    error,
    refetch,
  } = useProjectsInfo(currentOrganization?.id);
  const [api, notificationContextHolder] = notification.useNotification();

  const onSalesTargetTimePeriodChange = () => {
    refetch();
  };

  useEffect(() => {
    if (error) {
      api.error({
        message: "Error",
        description: (error as Error)?.message,
      });
    }
  }, [error, api]);

  return (
    <Flex vertical gap={variables.largeGap}>
      {notificationContextHolder}
      <Flex>
        <SalesTargetTimePeriods
          name='sales-target-time-periods'
          onChange={onSalesTargetTimePeriodChange}
        />
      </Flex>
      <Row gutter={{ xs: 4, sm: 8, md: 16, lg: 20 }} justify={"space-between"}>
        <Col span={16}>
          <EngineerDashboardProjectsCard
            loading={!isSuccess}
            engineeringProjects={projectsInfo?.engineeringProjects}
          />
        </Col>
        <Col span={8}>
          <NotesList title='My Project Notes' showCard />
        </Col>
      </Row>
    </Flex>
  );
};
